export default {
  emergencyHandle: {
    button: {
      add: '新增',
      query: '查询',
      reset: '重置',
      save:'保存',
      cancel:'取消',
      batchDel: '批量删除',
      edit: '修改',
      delete: '删除',
      confirm: '确认',
      choose:'选择'
    },
    tableColumn: {
      name: '名称',
    
    },
    label:{
      handleName:'处置卡名称',
      handleDevice:'处置卡设备',
      handleBuilding:'处置卡所属楼栋',
      handleProcessType:'处理类型',
      image:'图片',
      remark:'备注说明',
      handleProcessName:'名称',
      subHandleProcessType:'类型',
      handleProcessBase64:'现场处置说明',
      simpleProcessBase64:'简化流程说明'

    },
    placeholder:{
      remark:'请输入备注',
      handleName:'请输入处置卡名称',
      handleDevice:'请输入处置卡设备',
      handleProcessName:"请输入应急处理流程名称",
      handleProcessBase64:'请填写现场处置说明',

    },
    message:{
      addSuccess:"增加成功",
      editSuccess:"处置卡修改成功",
      less200: '备注信息不能超过200个字符',
      handleName:'请输入处置卡名称',
      handleDevice:'请输入处置卡设备',
      handleBuilding:'请选择处置卡所属楼栋',
      handleImage:'请上传图片',
      processName:"请输入应急处理流程名称",
      upWarn:"最大上传3张照片",
      formatWarn: '图片格式不正确, 请重新选择',
      sizeWarn: '图片大小不能超过4M',
      deltips: '您确定删除该应急卡吗?',
      batchDeltips: '您确定删除这些应急卡吗?',
      batchDel: '应急卡批量删除成功',
      selecttips: '请选择要删除的应急卡',
      delSuccess: '删除成功',
      selBuilding:'选择楼栋楼层'

    },
    title:{
      addHandleCard: '新增应急处置卡',
      editHandleCard: '修改应急处置卡',
      warn: '确认',
    }
  }
}